import { useScrollReveal } from "hooks/useScrollReveal";

const VARIANTS = {
    up: "reveal-up",
    down: "reveal-down",
    left: "reveal-left",
    right: "reveal-right",
    scale: "reveal-scale",
    fade: "reveal-fade",
};

const ScrollReveal = ({
    children,
    variant = "up",
    delay = 0,
    className = "",
    as: Tag = "div",
    threshold,
    rootMargin,
}) => {
    const { ref, isVisible } = useScrollReveal({ threshold, rootMargin });
    const variantClass = VARIANTS[variant] ?? VARIANTS.up;

    return (
        <Tag
            ref={ref}
            className={`reveal ${variantClass} ${isVisible ? "revealed" : ""} ${className}`}
            style={{ transitionDelay: `${delay}ms` }}
        >
            {children}
        </Tag>
    );
};

export default ScrollReveal;
